/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, observable, makeObservable } from 'mobx';
import { AzureObjectType } from '@veeam-vspc/models/web-controllers';

export class ProtectedAzureWorkloadsStore {

    @observable azureObjectType: AzureObjectType;

    constructor(type: AzureObjectType, readonly lsStateId: string) {
        makeObservable(this);
        this.azureObjectType = type;
    }

    @action.bound
    setAzureObjectType(v: AzureObjectType): void {
        this.azureObjectType = v;
    }
}
